export * from "/builds/dd3tech/wiggot/wiggot-web/packages/web-components/charts/comparables/index.tsx"